import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/images/logo.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  key: 0,
  class: "popup"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1)

import { onMounted, ref } from "vue";
import PCMain from "./PCMain.vue";
import MobileMain from "./MobileMain.vue";
import Button from "./components/CButton/index.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const isMobile = ref(
  navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
);
const popupVisible = ref(true);
const iframeRef = ref();

onMounted(() => {
  window.addEventListener("message", (e: MessageEvent<any>) => {
    if (typeof e.data === "object" && typeof e.data.openPopup === "boolean") {
      popupVisible.value = e.data.openPopup;
    }
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (popupVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!isMobile.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_3,
                _createVNode(PCMain, null, {
                  default: _withCtx(() => [
                    _createVNode(Button, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (popupVisible.value = false))
                    })
                  ]),
                  _: 1
                })
              ], 64))
            : (_openBlock(), _createBlock(MobileMain, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(Button, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (popupVisible.value = false))
                  })
                ]),
                _: 1
              }))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("iframe", {
      ref_key: "iframeRef",
      ref: iframeRef,
      frameborder: "0",
      style: {"width":"100vw","height":"100vh"},
      src: "./tour.html"
    }, null, 512)
  ]))
}
}

})